import React from 'react'
import {Header, Form} from 'semantic-ui-react'

const MetadataFields = ({ obj, language, onChange, legacy }) => {
  const fields = [
    {
      label: 'Titre',
      placeholder: 'Titre',
      id: 'meta_title'
    },
    {
      label: 'Description',
      placeholder: 'Description',
      id: 'meta_description'
    },
    {
      label: 'Tags',
      placeholder: 'Tags',
      id: 'meta_tags'
    },
    {
      label: 'Open Graph title',
      placeholder: 'Open Graph title',
      id: 'meta_og_title'
    },
    {
      label: 'Open Graph description',
      placeholder: 'Open Graph description',
      id: 'meta_og_description'
    },
    {
      label: 'Open Graph URL',
      placeholder: 'Open Graph URL (https://…)',
      id: 'meta_og_url'
    }
  ]

  const languageTitle = (language.language)
    ? language.language
    : language.label

  return (
    <div>
      <Header as='h3'>Métadonnées ({languageTitle})</Header>
      {fields.map(field => {
        let value = (obj.translations.hasOwnProperty(language.id))
          ? obj.translations[language.id][field.id]
          : obj.translations[language.code][field.id]

        // React doesn't like null values in Form.Input value attribute
        if (value === null) {
          value = ''
        }

        const languageId = (legacy) ? language.id : language.code

        return (
          <Form.Field key={field.id + '-' + languageId}>
            <Form.Input
              label={field.label}
              placeholder={field.placeholder}
              id={field.id}
              value={value}
              onChange={(e) => onChange(e, languageId)}
            />
          </Form.Field>
        )
      })}
    </div>
  )
}

export default MetadataFields



// WEBPACK FOOTER //
// ./src/components/form/Metadata.js